// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import { CreateFormQuestionAnswerModalVisibility } from '@lyon/scoped-models/form/create/CreateFormQuestionAnswerModalVisibility';
import { useFormDataType } from '@lyon/scoped-models/form/FormData';
import { useFormQuestionActiveValue } from '@lyon/scoped-models/form/FormQuestionActive';
import { FormQuestionAnswersData } from '@lyon/scoped-models/form/FormQuestionAnswersData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
// import { Divider } from '@lyon/components/utils/Divider';
import { LyonUpdateMultipleChoiceCaption } from './LyonUpdateMultipleChoiceCaption';
// import {
//   LyonUpdateMultipleChoiceCorrectFeedback
// } from './LyonUpdateMultipleChoiceCorrectFeedback';
// import {
//   LyonUpdateMultipleChoiceIncorrectFeedback
// } from './LyonUpdateMultipleChoiceIncorrectFeedback';
// import
//   LyonUpdateMultipleChoiceIndeterminateFeedback
// } from './LyonUpdateMultipleChoiceIndeterminateFeedback';
import { LyonUpdateMultipleChoiceName } from './LyonUpdateMultipleChoiceName';
import { LyonUpdateMultipleChoicePointsPossible } from './LyonUpdateMultipleChoicePointsPossible';
import { LyonUpdateMultipleChoiceAnswer } from './LyonUpdateMultipleChoiceAnswer';

export const LyonUpdateFormContentMultipleChoice = constant(() => {
  const formType = useFormDataType();
  const isQuiz = formType === 'quiz';
  const activeQuestionId = useFormQuestionActiveValue();

  if (!activeQuestionId) {
    return null;
  }

  return (
    <Block width="65%">
      <LyonUpdateMultipleChoiceName />
      <LyonUpdateMultipleChoiceCaption />
      <CreateFormQuestionAnswerModalVisibility.Provider>
        <FormQuestionAnswersData.Provider id={activeQuestionId}>
          {isQuiz && <LyonUpdateMultipleChoicePointsPossible />}
          <LyonUpdateMultipleChoiceAnswer />
        </FormQuestionAnswersData.Provider>
      </CreateFormQuestionAnswerModalVisibility.Provider>
      {/* {
        isQuiz && (
          <>
            <Divider />
            <LyonUpdateMultipleChoiceCorrectFeedback />
            <LyonUpdateMultipleChoiceIncorrectFeedback />
            <LyonUpdateMultipleChoiceIndeterminateFeedback />
          </>
        )
      } */}
    </Block>
  );
});
